import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { Menu } from "../../../components/menu-consultas";

export const LayoutConsultaVeiculo: React.FC = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <MUI.Stack pt={[2, 0]} flexDirection="row" width="100%" height="80vh">
      <Menu
        titulo="Consulta veículo"
        menu={[
          {
            to: "/consulta-veiculo/consulta-placa",
            label: "Pesquisa placa",
            icon: <Icon.TimeToLeave sx={{ color: "white" }} />,
            isSelected: pathname === "/consulta-veiculo/consulta-placa",
          },
          {
            to: "/consulta-veiculo/consulta-chassi",
            label: "Pesquisa chassi",
            icon: <Icon.TimeToLeave sx={{ color: "white" }} />,
            isSelected: pathname === "/consulta-veiculo/consulta-chassi",
          },

          {
            to: "/pagina-inicial",
            icon: <Icon.KeyboardReturn sx={{ color: "white" }} />,
            label: "Voltar página inicial",
          },
        ]}
      />
      <MUI.Stack flex={1} padding={2} gap={1} overflow="auto">
        {children}
      </MUI.Stack>
    </MUI.Stack>
  );
};
